import isPermissionEnabled from "common/isPermissionEnabled"

/**
 * Shared role+plan gates for cross-module dropdown / filter APIs.
 * Use on any screen that loads another module's list (branches, regions, etc.).
 */
export const getCrossModuleFilterPermissions = (
  userRole,
  accountType,
  accountScope
) => {
  const check = (categoryId, permissionId) =>
    isPermissionEnabled(
      userRole,
      categoryId,
      permissionId,
      accountType,
      accountScope
    )

  return {
    canFilterByBranch: check(5, "branchLocations_1"),
    canFilterByRegion: check(25, "region_1"),
    canFilterByCity: check(26, "city_1"),
    canFilterByCountry: check(11, "country_1"),
    canFilterByMenus: check(4, "menus_1"),
    canFilterByPromotion: check(14, "promotion_1"),
    canFilterByCustomers: check(7, "customersPermission_1"),
    canFilterByRoles: check(3, "roles_1"),
    canFilterByDeliveryPartners: check(47, "delivery_partners_1"),
    canFilterByBrands: check(52, "brands_1"),
  }
}
